import type {z} from "zod";

import {ContactInputFields, PhoneNumberInput} from "@project/sdk/sales/zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {contactFieldLabelIds} from "../../../../../../../support/messages/contact.messages";

const contactInputFields = ContactInputFields.shape;

export const editRepresentativeContactNameSchema = requiredStringSchema(
  contactInputFields.name,
  contactFieldLabelIds.name,
);
export const editRepresentativeContactEmailSchema = contactInputFields.email.or(zod.literal(""));

const editRepresentativeContactFormFieldsSchema = zod.object({
  name: editRepresentativeContactNameSchema,
  description: contactInputFields.description,
  email: editRepresentativeContactEmailSchema,
  phone: PhoneNumberInput.shape.nationalNumber.optional(),
  phonePrefix: PhoneNumberInput.shape.regionCode.optional(),
});

export const editRepresentativeContactFormSchema =
  editRepresentativeContactFormFieldsSchema.superRefine((value, ctx) => {
    if (!value.email && !value.phone) {
      ctx.addIssue({code: "custom", message: "Email or phone is required", path: ["email"]});
    }

    if (value.phone && !value.phonePrefix) {
      ctx.addIssue({
        code: "custom",
        message: "Phone prefix is required",
        path: ["phonePrefix"],
      });
    }
  });
export type EditRepresentativeContactFormPayload = z.output<
  typeof editRepresentativeContactFormSchema
>;

export const draftEditRepresentativeContactFormSchema =
  editRepresentativeContactFormFieldsSchema.partial();
export type DraftEditRepresentativeContactFormPayload = z.output<
  typeof draftEditRepresentativeContactFormSchema
>;
